function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Svg from './Svg';
import styled from 'styled-components';
const BaseComponent = ({
  size = 24,
  title,
  desc,
  titleId,
  descId,
  tabIndex = -1,
  focusable = false,
  role = 'img',
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  let ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? ` ${descId}` : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": ariaHidden,
    fill: "currentcolor",
    role: role,
    tabIndex: tabIndex,
    focusable: focusable
  }, props), !!title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/React.createElement("path", {
    d: "M12 22a9.738 9.738 0 01-3.9-.788 10.099 10.099 0 01-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175A9.738 9.738 0 012 12c0-1.25.242-2.475.725-3.675A10.49 10.49 0 014.75 5.113c.867-.942 1.908-1.7 3.125-2.276 1.217-.575 2.55-.862 4-.862.35 0 .708.017 1.075.05s.742.092 1.125.175c-.15.75-.1 1.458.15 2.125s.625 1.22 1.125 1.662c.5.442 1.096.746 1.787.913.692.167 1.405.125 2.138-.125-.433.983-.37 1.925.188 2.825.558.9 1.387 1.367 2.487 1.4a9.824 9.824 0 01.05 1.025 9.587 9.587 0 01-.788 3.862 10.292 10.292 0 01-2.137 3.175 9.994 9.994 0 01-3.175 2.15A9.738 9.738 0 0112 22zm-1.5-12c.417 0 .77-.146 1.063-.438.291-.291.437-.645.437-1.062 0-.417-.146-.77-.438-1.063A1.447 1.447 0 0010.5 7c-.417 0-.77.146-1.063.438A1.447 1.447 0 009 8.5c0 .417.146.77.438 1.063.291.291.645.437 1.062.437zm-2 5c.417 0 .77-.146 1.063-.438.291-.291.437-.645.437-1.062 0-.417-.146-.77-.438-1.063A1.446 1.446 0 008.5 12c-.417 0-.77.146-1.063.438A1.447 1.447 0 007 13.5c0 .417.146.77.438 1.063.291.291.645.437 1.062.437zm6.5 1c.283 0 .52-.096.713-.287A.968.968 0 0016 15a.968.968 0 00-.287-.713A.968.968 0 0015 14a.968.968 0 00-.713.287A.968.968 0 0014 15c0 .283.096.52.287.713.192.191.43.287.713.287zm-3 4c2.033 0 3.838-.7 5.413-2.1 1.575-1.4 2.437-3.183 2.587-5.35-.833-.367-1.488-.867-1.962-1.5a5.357 5.357 0 01-.963-2.125 5.688 5.688 0 01-3.3-1.65 5.961 5.961 0 01-1.7-3.3c-1.333-.033-2.504.208-3.512.725-1.009.517-1.85 1.18-2.526 1.987a8.673 8.673 0 00-1.524 2.638C4.17 10.275 4 11.167 4 12c0 2.217.78 4.104 2.338 5.663C7.896 19.22 9.783 20 12 20z"
  }));
};
const SvgSnack = styled(BaseComponent).withConfig({
  displayName: "Snack__SvgSnack",
  componentId: "sc-12oa8dj-0"
})(["outline:none;"]);
SvgSnack.isIcon = true;
export default SvgSnack;